import type { TypeFile } from '../step4/hooks/types';

export type ContractUploadFieldDef = {
  key: TypeFile;
  label: string;
  showSerialHelp?: boolean;
  optional?: boolean;
  fullWidth?: boolean;
};

type UploadContext = {
  hasInvoice: boolean;
  isNew: boolean;
  productId: number[];
  equipmentTypeId?: number;
};

export function getContractUploadFields({
  hasInvoice,
  isNew,
  productId,
  equipmentTypeId
}: UploadContext): ContractUploadFieldDef[] {
  if (hasInvoice && isNew) {
    return [{ key: 'invoice', label: 'Nota Fiscal' }];
  }

  if (hasInvoice && !isNew && productId.includes(5)) {
    const fields: ContractUploadFieldDef[] = [
      { key: 'invoice', label: 'Nota Fiscal' },
      { key: 'serial_number_photo', label: 'Número de série', showSerialHelp: true },
      { key: 'right_side_overview', label: 'Visão geral (Lado direito)' },
      { key: 'left_side_overview', label: 'Visão geral (Lado esquerdo)' },
      { key: 'ratchets_group', label: 'Grupo de catracas' },
      { key: 'front_wheel', label: 'Roda dianteira' },
      { key: 'rear_wheel', label: 'Roda traseira' },
      { key: 'front', label: 'Frontal' }
    ];

    if (equipmentTypeId !== 4) {
      fields.push({ key: 'front_gear_shift', label: 'Câmbio dianteiro' });
    }

    fields.push(
      { key: 'rear_gear_shift', label: 'Câmbio traseiro' },
      { key: 'other', label: 'Outras fotos', optional: true, fullWidth: true }
    );

    return fields;
  }

  if (hasInvoice && !isNew) {
    return [
      { key: 'invoice', label: 'Nota Fiscal' },
      { key: 'overview', label: 'Equipamento inteiro' },
      { key: 'serial_number_photo', label: 'Número de série', showSerialHelp: true },
      { key: 'ratchets_group', label: 'Grupo de catracas' }
    ];
  }

  return [
    { key: 'overview', label: 'Equipamento inteiro' },
    { key: 'serial_number_photo', label: 'Número de série', showSerialHelp: true },
    { key: 'ratchets_group', label: 'Grupo de catracas' }
  ];
}
